<template>
  <div id="app" @click="xTableClick">
    <div id="header" class="hide-indicator">
      <div id="logoBox">
        <img id="imgLogo" src="//hpublic-zw.obs.cn-south-1.myhuaweicloud.com/anycubic-hlogo.png" />
      </div>
      <i id="logoLight" class="light"></i>
      <ul id="menuBar" class="header-menu">
        <li v-for="(item, index) in meunListData" @mouseover="mouseOver($event, 'menu-item primary open')" @mouseleave="mouseLeave($event, 'menu-item primary')" class="menu-item primary" :key="index">
          <div class="indicator"></div>
          <span class="label">{{ item.menuName }}</span>
          <i class="icon angle down el-icon-arrow-down"></i>
          <ul class="popup-menu">
            <li class="menu-item level-2 group-header" v-for="(ulItem, ulIndex) in item.children" :key="ulIndex">
              <div class="indicator"></div>
              <span class="label">{{ ulItem.menuName }}</span>
              <ul class="children">
                <li class="menu-item level-3" v-for="(liItem, liIndex) in ulItem.children" @click.stop="replaceUrlFun(liItem.menuId, liItem)" :key="liIndex">
                  <div class="indicator"></div>
                  <img :src="liItem.icon" alt="" class="icon" />
                  <span class="label">{{ liItem.menuName }}</span>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <ul id="menuBarRight" class="header-menu right">
        <li class="menu-item my" @mouseover="mouseOver($event, 'menu-item my service open')" @mouseleave="mouseLeave($event, 'menu-item my service')">
          <i class="icon menu-icon my"></i>
          <span class="label" _d="_id204">{{ userName }}</span>
          <i class="icon angle down el-icon-arrow-down"></i>
          <ul id="popupMenuMy" class="popup-menu" style="width: 160px">
            <a class="menu-item" _d="_id8298">
              <span class="label" _d="_id8302" style="display: block; padding-left: 15px" @click="centerDialogVisible = true"><i class="el-icon-edit-outline"></i> 修改密码</span>
            </a>
          </ul>
        </li>
        <li class="menu-item service" @mouseover="mouseOver($event, 'menu-item service open')" @mouseleave="mouseLeave($event, 'menu-item service')">
          <i class="icon menu-icon service"></i>
          <ul id="menuServicePopup" class="popup-menu">
            <li class="kf-box">
              <a href="javascript:;" class="kf-header">
                <span>产品经理</span>
              </a>
              <div class="line" v-for="(item, index) in userList" :key="index">
                {{ item.user }}
              </div>
            </li>
          </ul>
        </li>
        <li class="menu-item service" @mouseover="mouseOver($event, 'menu-item service open')" @mouseleave="mouseLeave($event, 'menu-item service')">
          <img src="http://hpublic-zw.obs.cn-south-1.myhuaweicloud.com/lib/icon/word.png" style="width: 24px; height: 24px; margin: 13px 5px 0 5px" />
          <ul id="menuServicePopup" class="popup-menu">
            <li class="kf-box">
              <a href="javascript:;" class="kf-header">
                {{ operationManual.title }}
              </a>
              <div class="line" v-for="(item, index) in operationManual.items" :key="index">
                <a v-for="(i, j) in item" :key="j" :href="i.url" :style="i.style" target="_blank">{{ i.name }} <i class="el-icon-arrow-right"></i></a>
              </div>
            </li>
          </ul>
        </li>
        <li class="menu-item service">
          <i class="icon menu-icon el-icon-switch-button" @click="out"></i>
        </li>
      </ul>
    </div>
    <div id="workspace" class="show-on-ready">
      <div id="tabsetMain" change="onTabsetChange" class="ui c-tab top-tab focused">
        <nav style="margin-right: 206.625px">
          <draggable class="tabs" style="left: 0px" @end="onDragEnd">
            <div
              v-for="(item, index) in iframeList"
              :key="item.id"
              @contextmenu.prevent="openContextMenu($event, index, item)"
              class="tab"
              :class="`ui tab-button  visible ui-sortable-handle slide-up-button   slide-down ${item.id === iframeActIndex ? 'active ' : ''}`"
            >
              <div v-show="item.isOpen" style="color: #0869bd">&bull;</div>
              <div class="caption" @click="active(item, index)">
                <span>{{ item.name }}</span>
              </div>
              <div class="close-btn" @click="closeIframe(item, index)">
                <i class="close icon"></i>
              </div>
            </div>
          </draggable>
          <div v-show="menuVisible" class="context-menu transition">
            <ul>
              <li @click="refreshHandle"><i class="el-icon-refresh"></i> 刷新</li>
              <li @click="autoOpenHandle">
                <i v-show="isTage == '1'" class="el-icon-star-off"></i>
                <i v-show="isTage == '2'" class="el-icon-star-on blueColor"></i>
                设置为自动打开
              </li>
              <li @click="closeAll"><i class="el-icon-close"></i> 关闭其他</li>
              <li @click="closeLeft"><i class="el-icon-back"></i> 关闭左侧</li>
              <li @click="closeRight"><i class="el-icon-right"></i> 关闭右侧</li>
            </ul>
          </div>
        </nav>
        <div id="tabbarButtons" class="tabbar-buttons">
          <div id="buttonTask" class="tabbar-button reserve" @click="taskVisible = true"></div>
          <div id="buttonFullScreen" class="tabbar-button" @click="fullScreenHandle">
            <i class="icon icon-fullscreen"></i>
          </div>
          <div id="buttonRefresh" class="tabbar-button" @click="refreshHandle">
            <i class="icon icon-refresh1"></i>
          </div>
          <div id="buttonSync" class="tabbar-button">
            <i id="iconSyncOrder" class="icon"></i>
            <label @click="outerVisible = true">同步订单</label>
          </div>
        </div>
        <div id="pane-dev" style="display: block"></div>
        <!--任务中心-->
        <MissionCenter v-show="messagekVisible" ref="missionCenter" @close="messagekVisible = false"> </MissionCenter>
        <!--iframe-->
        <div v-show="!messagekVisible" class="contents">
          <div id="iframeBox">
            <iframeIndex v-show="iframeActIndex == item.id" v-for="item of iframeList" :key="item.id" :url="item.url"></iframeIndex>
          </div>
        </div>
      </div>
    </div>
    <SyncOrder :outerVisible="outerVisible" ref="syncOrder" @close="outerVisible = false" @pulling="pullingHandle"></SyncOrder>
    <MessageTask :taskVisible="taskVisible" :taskData="taskData" @moreHandle="moreHandle" @close="taskVisible = false"> </MessageTask>
    <ChangePassword :centerDialogVisible="centerDialogVisible" :userId="userId" @close="centerDialogVisible = false"></ChangePassword>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import "@/assets/styles/frame.css";
import { meunList, taskList, longPolling, getUserByContext, addUserAutoMenu, deleteUserAutoMenu } from "@/api/home";
import { menu } from "@/lib/menu";
import iframeIndex from "@/views/contents.vue";
import SyncOrder from "./components/SyncOrder";
import MessageTask from "./components/MessageTask";
import MissionCenter from "./components/MissionCenter";
import ChangePassword from "./components/ChangePassword";
import moment from "moment";
import { fixContains } from "@/utils/methods";
import { BASE_URL, PRINT_URL } from "@/config/index.js";
import keycloak from '@/utils/keycloak.js'
import { updateToken } from '@/utils/auth'

export default {
  name: "home",
  components: {
    iframeIndex,
    SyncOrder,
    MessageTask,
    MissionCenter,
    ChangePassword,
    draggable,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      isTage: "1",
      markList: [],
      timeNumber: 0,
      itemObject: {},
      centerDialogVisible: false,
      account: "",
      userName: "",
      userId: "",
      currentIndex: null,
      menuVisible: false,
      messagekVisible: false,
      taskVisible: false,
      outerVisible: false,
      iframeActIndex: null,
      iframeList: [],
      meunListData: [],
      isPop: false,
      // routerList: [],
      taskData: [],
      exportTimer: false,
      pullingTimer: false,
      operationManual: {
        title: "操作手册文档",
        items: [
          [
            {
              url: "https://doc.weixin.qq.com/doc/w3_AZsA5wZxAH8QAh4U5htQlyfhCEzx1?scode=ACwAIAf6AA0kXit5LdAZsA5wZxAH8&amp;version=4.1.2.6017&amp;platform=win",
              name: "基础设置",
              style: "margin-right:50px;",
            },
            {
              url: "https://doc.weixin.qq.com/doc/w3_AZsA5wZxAH8rF2DZjsQSsW2GqmtMw?scode=ACwAIAf6AA0BHV0HITAZsA5wZxAH8&amp;version=4.1.2.6017&amp;platform=win",
              name: "商品管理",
            },
          ],
          [
            {
              url: "https://doc.weixin.qq.com/doc/w3_AJAAXgbaAEsfkpwtXlOSp0lYzE9A3?scode=ACwAIAf6AA0aFW2OYHAJAAXgbaAEs&version=4.1.2.6017&platform=win",
              name: "头程管理",
              style: "margin-right:50px;",
            },
            {
              url: "https://doc.weixin.qq.com/doc/w3_AZsA5wZxAH8u8CVqwI9QJ6muQFSSI?scode=ACwAIAf6AA0vRjb6EZ",
              name: "订单管理",
            },
          ],
          [
            {
              url: "https://doc.weixin.qq.com/doc/w3_AcEAkgY6AEInAac0NyoQyaEJYCvJ3?scode=ACwAIAf6AA0gOJSWhGAcEAkgY6AEI&amp;version=4.1.2.6011&amp;platform=win",
              name: "库存管理",
              style: "margin-right:50px;",
            },
            {
              url: "https://doc.weixin.qq.com/doc/w3_AWwAywa3ABIrcu03akJQWKD8OC6tK?scode=ACwAIAf6AA01U3O14qAWwAywa3ABI&amp;version=4.1.2.6017&amp;platform=win",
              name: "客服管理",
            },
          ],
        ],
      },
      userList: [{ user: "商品、设置、订单 ： 杨盼盼", },{ user: "库存、客服 ： 刘先俊",},{ user: "头程、报表 ： 龙梦华", },],
    };
  },
  methods: {
    pullingHandle() {
      let pullingNumber = localStorage.getItem("pullingNumber");
      if (pullingNumber == "null" || pullingNumber == 0) {
        localStorage.setItem("pullingNumber", 1);
      } else {
        localStorage.setItem("pullingNumber", parseInt(pullingNumber++));
      }
      if (!this.pullingTimer) {
        this.pullingTimer = true;
        this.pullingFunction();
      }
    },
    // 轮巡查询 导出消息接口
    pullingFunction() {
      longPolling({ type: 1 }).then((res) => {
        let pullingNumber = localStorage.getItem("pullingNumber");
        if (res.length) {
          res.forEach((item) => {
            if (item.msg) {
              this.$notify.info({
                type: "success",
                title: "同步订单消息",
                showClose: true,
                message: item.msg,
                offset: 60,
              });
            }
          });
          if (pullingNumber > res.length) {
            localStorage.setItem("pullingNumber", parseInt(pullingNumber - res.length));
          } else {
            this.pullingTimer = false;
            localStorage.setItem("pullingNumber", 0);
            this.$refs.syncOrder.clearParms();
            this.outerVisible = false;
          }
        } else {
          // 缓存数据大于0有需要拉去数据
          if (pullingNumber > 0) {
            this.timeNumber++;
            if (this.timeNumber > 150) {
              this.timeNumber = 0;
              this.pullingTimer = false;
            }
          } else {
            this.pullingTimer = false;
          }
        }
        if (this.pullingTimer) {
          // 如果仍然需要轮询，继续调用
          setTimeout(this.pullingFunction, 1000); // 每3秒钟调用一次
        }
      });
    },
    xTableClick(e) {
      const el = e.target;
      const wrap = document.querySelector(".workspace .tabs");
      if (!fixContains(wrap, el) && this.menuVisible) {
        this.menuVisible = false;
      }
    },
    onDragEnd(event) {
      // 拖拽结束后的处理逻辑
      const movedElement = this.iframeList.splice(event.oldIndex, 1)[0];
      this.iframeList.splice(event.newIndex, 0, movedElement);
    },
    openContextMenu(event, index, item) {
      if (item.isOpen) {
        this.isTage = "2";
      } else {
        this.isTage = "1";
      }
      this.itemObject = item;
      this.currentIndex = index;
      this.menuVisible = true;
      // 位置调整，确保菜单出现在鼠标位置
      this.setMenuPosition(event);
    },
    //设置为星际标签
    async autoOpenHandle() {
      let isFlage = this.markList.some((item) => {
        return item.menuId === this.itemObject.id;
      });
      if (!isFlage) {
        this.markList.push({
          menuId: this.itemObject.id,
          menuName: this.itemObject.name,
          url: this.itemObject.url,
        });
        this.iframeList.forEach((item) => {
          if (item.id === this.itemObject.id) {
            item.isOpen = true;
          }
        });
        await addUserAutoMenu(this.markList);
      } else {
        this.iframeList.forEach((item) => {
          if (item.id === this.itemObject.id) {
            item.isOpen = false;
          }
        });
        await deleteUserAutoMenu({ menuId: this.itemObject.id });
      }
    },
    setMenuPosition(event) {
      const menu = this.$el.querySelector(".context-menu");
      menu.style.top = `${event.clientY}px`;
      menu.style.left = `${event.clientX}px`;
    },
    // 关闭所有的逻辑
    closeAll() {
      this.iframeList = this.iframeList.filter((item, index) => {
        return index === this.currentIndex;
      });
      this.iframeActIndex = this.iframeList[0].id;
      this.$router.replace( `/${this.iframeActIndex}`, () => {},() => {});
    },
    // 关闭左侧
    closeLeft() {
      if (this.currentIndex > 0) {
        this.iframeList.splice(this.currentIndex - 1, 1);
        this.iframeActIndex = this.iframeList[this.currentIndex - 1].id;
      }
    },
    // 关闭左侧
    closeRight() {
      if (this.iframeList.length > 0) {
        this.iframeList.splice(this.currentIndex + 1, 1);
        this.iframeActIndex = this.iframeList[this.currentIndex].id;
      }
    },
    // 更多消息列表
    moreHandle() {
      this.$refs.missionCenter.taskDataHandle();
      this.messagekVisible = true;
      this.taskVisible = false;
      if (!this.iframeList.some((item) => item.id === "missionCenter")) {
        this.iframeList.push({
          name: "任务中心",
          id: "missionCenter",
          url: "missionCenter",
        });
      }
      this.iframeList.forEach((item, index) => {
        if (item.id === "missionCenter") {
          this.iframeActIndex = item.id;
        }
      });
      this.$router.replace(`/missionCenter`,() => {},() => {});
    },
    // token过期
    async receiveMessage(event) {
      if (event.data === "callParentMethod") {
        // this.$router.replace(`/login`);
        try {
          await updateToken()
          // 通知 iframe：成功
          event.source.postMessage('tokenRefreshed', event.origin);
        } catch (e) {
          // 通知 iframe：失败
          event.source.postMessage('tokenRefreshFailed', event.origin);
        }
      }
    },
    // 接收来自父级页面导入导出消息
    taskInfo(event) {
      const { type, payload } = event.data || {};
      if (type !== 'taskInfo'&&payload.id) return;
      this.taskVisible = true;
      this.taskListHandle();
      if (!this.exportTimer) {
        this.exportTimer = true;
        this.myFunction();
      }
    },
    printTagOpen(event) {
      const { type, url } = event.data || {};
      if (type !== 'printTagOpen') return
      console.log(event, "打印");
      const regexIgnoreCase = /\bprint\?\b/;
      if (regexIgnoreCase.test(url)) {
        let printId = print + new Date().getTime();
        this.iframeActIndex = printId;
        this.iframeList.push({
          name: "打印模板",
          id: printId,
          url: `${BASE_URL}/print/#/${url}`,
          // url:`http://localhost:8080/${route.path}/index.html`
        });
      }
    },
    // 接收来自父级页面更新商品消息
    longPollingInfo(event) {
      if (event.data === "longPollingInfo") {
        this.pullingHandle();
      }
    },
    // 轮巡查询 导出消息接口
    myFunction() {
      longPolling({ type: 0 }).then((res) => {
        let newData = res.filter((item) => {
          return item.state === "complete" || item.state === "error"|| item.state === "cancelled";
        });
        if (newData.length > 0) {
          newData.forEach((item) => {
            this.taskData.forEach((j) => {
              if (j.id === item.taskId) {
                j.state = item.state;
                j.result.url = item.url;
                j.message = item.msg;
              }
            });
          });
          setTimeout(this.myFunction, 1000);
          this.taskListHandle();
        } else {
          this.taskData.forEach((item) => {
            if (item.state == "running") {
              let create = new Date(moment(item.createTime).format("YYYY-MM-DD HH:mm:ss")).getTime();
              let newData = new Date().getTime();
              let inceTime = parseInt((newData - create) / 1000);
              const hours = Math.floor(inceTime / 3600); // 转换为小时
              const minutes = Math.floor((inceTime % 3600) / 60); // 转换为分钟
              const seconds = inceTime % 60; // 转换为秒钟
              const formattedTime = hours + ":" + ("0" + minutes).slice(-2) + ":" + ("0" + seconds).slice(-2);
              item.time = formattedTime;
              if (minutes >= 10) {
                this.exportTimer = false;
                this.taskListHandle();
              }
            }
          });
          if (this.exportTimer) {
            setTimeout(this.myFunction, 1000);
          }
          // 如果list中没有 running 状态的数据 关闭定时请求
          let isFlage = this.taskData.some((res) => {
            return res.state === "running";
          });
          if (!isFlage) {
            this.exportTimer = false;
          }
        }
      });
    },
    /**
     * 全屏功能
     */
    fullScreenHandle() {
      var div = document.getElementById("app");
      this.toggleFullScreen(div);
    },
    /**
     * 刷新
     */
    refreshHandle() {
      this.iframeList.forEach((item) => {
        if (this.iframeActIndex === "missionCenter") {
          this.$refs.missionCenter.taskDataHandle();
        }
        if (item.id === this.iframeActIndex) {
          item.url = `${item.url}?v=${new Date().getTime()}`;
        }
      });
    },
    getLastParam(str) {
      const parts = str.split("/").filter(Boolean); // 使用 '/' 分割字符串，并去除空字符串
      return parts[parts.length - 1]; // 返回最后一部分
    },
    active(item) {
      if (item.id === "missionCenter") {
        this.messagekVisible = true;
        this.iframeActIndex = item.id;
      } else {
        this.messagekVisible = false;
        this.iframeActIndex = item.id;
      }
      this.$router.replace(`/${item.id}`,() => {},() => {});
    },
    closeIframe(item, index) {
      this.iframeList.splice(index, 1);
      if (this.iframeList.length == 0) {
        this.iframeActIndex = null;
        this.$router.replace(`/`,() => {},() => {});
        this.menuVisible = false;
        this.messagekVisible = false;
      } else {
        if (item.id == "missionCenter") {
          this.messagekVisible = false;
        }
        if (index === 0 || index === this.iframeList.length) {
          this.iframeActIndex = this.iframeList[index - 1].id;
        } else {
          this.iframeActIndex = this.iframeList[this.iframeList.length].id;
        }
        this.$router.replace(`/${this.iframeActIndex}`, () => {},() => {} );
      }
    },
    replaceUrlFun(id, item) {
      this.menuVisible = false;
      if (id === "missionCenter") {
        this.messagekVisible = true;
      } else {
        this.messagekVisible = false;
        const route = menu.find((e) => {
          if (e.id == id) {
            document.title = `欢迎使用跨境业务中台：${e.name}`;
            return e;
          }
        });
        const flag = this.iframeList.some((e) => {
          return e.id == id;
        });

        if (flag) {
          this.iframeList.forEach((item, index) => {
            if (item.id === id) {
              this.iframeActIndex = item.id;
            }
          });
          return;
        }
        if (item) {
          if (item.isFrame == "0") {
            let rote = item;
            this.iframeList.push({
              name: rote.menuName || route.name,
              id: id,
              path: rote.outPath,
              url: `${PRINT_URL}/login/acerpToCerpLogin?account=${this.account}&url=${rote.outPath}`,
            });
          } else {
            this.iframeList.push({
              name: route.name,
              id: route.id,
              path: route.path,
              url: `${BASE_URL}/${route.path}/index.html` // http://localhost:8080/
              // url: `http://localhost:8080/${route.path}/index.html`,
            });
          }
        } else {
          this.iframeList.push({
            name: route.name,
            id: route.id,
            path: route.path,
            url: `${BASE_URL}/${route.path}/index.html`
            // url: `http://localhost:8080/${route.path}/index.html`,
          });
        }
        this.iframeActIndex = id;
        if (this.iframeList.length > 0) {
          this.iframeList.forEach((item) => {
            if (item.id) {
              this.$router.replace(`/${item.id}`,() => {},() => {} );
            }
          });
        } else {
          this.$router.replace(`/`);
        }
      }
    },
    taskListHandle() {
      let olderDay = moment().subtract(6, "days").format("yyyy-MM-DD");
      // 输出或返回格式化后的日期
      taskList({ beginDate: olderDay, pageSize: 20 }).then((res) => {
        res.$data.forEach((item) => {
          item.time = "";
          this.taskData = res.$data;
          if (item.state === "running") {
            if (!this.exportTimer) {
              this.exportTimer = true;
              this.myFunction();
            }
          }
        });
      });
    },
    mouseOver($event, str) {
      $event.currentTarget.className = str;
    },
    mouseLeave($event, str) {
      $event.currentTarget.className = str;
    },
    out() {
      this.$confirm("是否退出账号?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const loginOrigin = localStorage.getItem('loginOrigin')||null;
          if (loginOrigin==='token') {
            localStorage.clear(); 
            window.location.reload();
          }else{
            keycloak.logout().then(()=>{ 
              console.log('登出成功') 
            }) 
            localStorage.clear(); 
            this.$router.replace("/", () => {});
          }
        })
        .catch(() => {});
    },
    leave() {
      var _this = this;
      this.onOff = false;
      var timer = setTimeout(function () {
        clearTimeout(timer);
        if (!_this.onOff) _this.isPop = false;
      }, 300);
    },
    enter() {
      var _this = this;
      this.onOff = true;
      var timer = setTimeout(function () {
        _this.isPop = true;
        clearTimeout(timer);
      }, 300);
    },
    /**
     * div 全屏功能
     */
    toggleFullScreen(elem) {
      if (!document.fullscreenElement) {
        // 判断当前是否处于全屏状态
        if (elem.requestFullscreen) {
          elem.requestFullscreen(); // W3C 规范
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen(); // Firefox 旧版
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen(); // Chrome等
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen(); // IE 11
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen(); // W3C 规范
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen(); // Firefox 旧版
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen(); // Chrome等
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen(); // IE 11
        }
      }
    },
    handleVisibilityChange() {
      if (document.visibilityState === "hidden") {
        // 页面可能即将被刷新
        let item = this.iframeList.filter((item) => {
          return item.id === this.iframeActIndex;
        });
        localStorage.setItem("urlData", JSON.stringify(item));
        console.log(item, this.iframeList, "页面可能即将被刷新");
      }
    },
    // Message 事件监听
    handleMessage(event) {
      if (event.data) {
        const type  = event.data.type? event.data.type : event.data;
        switch (type) {
          case 'callParentMethod':
            this.receiveMessage(event);
            break;
          case 'taskInfo':
            this.taskInfo(event);
            break;
          case 'longPollingInfo':
            this.longPollingInfo(event);
            break;
          case 'printTagOpen':
            this.printTagOpen(event);
        }
      }
    }
  },
  created() {
    getUserByContext().then((res) => {
      this.account = res.account;
      this.userName = res.nickName;
      this.userId = res.userId;
      this.markList = res.autoMenus || [];
      localStorage.setItem("account", res.account);
      let ownershipRestriction = [...new Set([...res.menuIds, ...res.pdaMenuIds, ...res.dataMenuIds])]; // 数据权限，pda权限， data权限
      localStorage.setItem("operationMenuIds", JSON.stringify(ownershipRestriction));
      if (res.autoMenus.length > 0) {
        this.iframeList = [];
        res.autoMenus.forEach((item) => {
          this.iframeList.push({
            id: item.menuId,
            name: item.menuName,
            isOpen: true,
            url: item.url,
          });
        });
        let urlParmas = this.getLastParam(window.location.href);
        console.log(urlParmas, "获取url末尾参数");
        if (urlParmas != "#") {
          this.iframeActIndex = urlParmas;
        } else {
          this.messagekVisible = false;
          this.iframeActIndex = res.autoMenus[0].menuId;
          this.$router.replace(
            `/${res.autoMenus[0].menuId}`,
            () => {},
            () => {}
          );
          if (this.iframeActIndex === "missionCenter") {
            this.messagekVisible = true;
          }
        }
      }
    });
    document.title = `欢迎使用跨境业务中台`;
    meunList()
      .then((res) => {
        this.meunListData = res;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  mounted() {
    //-token过期
    // window.addEventListener("message", this.receiveMessage, false);
    //-导出模板消息
    // window.addEventListener("message", this.taskInfo);
    //-关联店铺消息
    // window.addEventListener("message", this.longPollingInfo);
    // -打印模板
    // window.addEventListener("message", this.printTagOpen);

    // 统一监听组件通讯
    window.addEventListener("message", this.handleMessage);

    //-页面刷新消息
    window.addEventListener("visibilitychange", this.handleVisibilityChange);
    let item = localStorage.getItem("urlData");
    let data = JSON.parse(item);
    if (data && data.length) {
      this.iframeList = data;
      this.messagekVisible = false;
      this.iframeActIndex = data[0].id;
      if (this.iframeActIndex === "missionCenter") {
        this.messagekVisible = true;
      }
    }
    // 页面重新加载，调用一下导出订单接口，看有没有running中的数据
    this.taskListHandle();
  },
  destroyed() {
    this.pullingTimer = false;
    this.exportTimer = false;
    // window.removeEventListener("message", this.taskInfo);
    // window.removeEventListener("message", this.longPollingInfo);
    window.removeEventListener("message", this.handleMessage);

    // 移除事件监听
    window.removeEventListener("visibilitychange", this.handleVisibilityChange);
  },
};
</script>
<style scoped>
::v-deep .el-form-item__label {font-size: 12px;line-height: 28px;}
::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  font-size: 12px;
}
::v-deep .el-form-item__content,
.el-cascader,
.el-input__icon {
  line-height: 28px !important;
}
::v-deep .el-input__icon {
  line-height: 28px !important;
}
::v-deep .el-button--primary {
  border-color: #0869bd;
  background: #0869bd;
}
.calf {
  background: none !important;
}
.ui.popup .tip-content {
  margin: 12px;
}
.ui.popup .tip-buttons {
  margin: 24px 12px 12px 12px;
  text-align: right;
}
#dialogDownloadVerify .tip {
  margin-top: 8px;
}
#dialogDownloadVerify .tip.failed {
  color: #fa4e3e;
}
.calf #header #menuBar {
  padding: 0 190px 0 210px;
}
#header {
  background-color: #23426e;
}
#header > ul.header-menu > .menu-item {
  background-color: #23426e;
}
.calf #header > ul.header-menu > .menu-item.open {
  background-color: #2e5489;
}
#header.hide-indicator > ul.header-menu > .menu-item.active {
  background-color: #2e5489;
}
#header #logoBox #imgLogo {
  position: absolute;
  left: 0;
  top: 0;
  height: auto;
}
.blueColor {
  color: #0869bd;
}
.contents {
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  position: relative;
  padding: 0;
  margin: 0;
  height: calc(100vh - 82px);
  list-style: none;
}
.ui.c-tab > nav > .tabs > .tab > * {
  float: left;
}
.ui.c-tab > nav > .tabs > .tab .close-btn {
  opacity: 0.3;
  margin-left: 0.4em;
}
.ui.c-tab.top-tab > nav > .tabs > .tab,
.ui.c-tab.bottom-tab > nav > .tabs > .tab {
  border-right: 1px solid #d9d9d9;
}
.ui.c-tab > nav > .tabs > .tab {
  background: #ededed;
  list-style-type: none;
  position: relative;
  padding: 0 0.8em;
  cursor: pointer;
  line-height: 32px;
  float: left;
  font-size: 12px;
  transition-duration: 0.2s;
  transition-property: background-color, border-color, color, box-shadow, transform;
}
.context-menu {
  position: fixed;
  width: 120px;
  min-height: 80px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 1rem 0em;
  z-index: 1002;
  background: #ffffff;
  font-weight: normal;
  border: 1px solid rgba(34, 36, 38, 0.15);
  -webkit-box-shadow: 0px 1px 2px 0 rgb(34 36 38 / 15%);
  box-shadow: 0px 1px 2px 0 rgb(34 36 38 / 15%);
  border-radius: 4px;
  min-height: 2.83333333em;
}
.transition {
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  -webkit-animation-duration: 300ms;
  animation-duration: 300ms;
  -webkit-animation-timing-function: ease;
  animation-timing-function: ease;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.context-menu ul {
  display: block;
  width: 120px;
  min-height: 80px;
}
.context-menu li {
  display: block;
  line-height: 40px;
  padding: 0 10px;
  cursor: pointer;
  font-size: 12px;
}
.context-menu li:hover {
  background: #eee;
}
.tab {
  display: block;
}
.ui.c-tab > nav > .tabs {
  z-index: 500;
  list-style: none;
  padding: 0;
  margin: 0;
  transition-duration: 0.2s;
  transition-property: left, top;
}
.ui.c-tab.top-tab > nav > .tabs,
.ui.c-tab.bottom-tab > nav > .tabs {
  width: 4800px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}
.ui.c-tab > nav {
  overflow: hidden;
  background: #ededed;
}
.ui.c-tab.top-tab > nav {
  position: relative;
  -webkit-box-flex: 0;
  -moz-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
}
#iframeBox {
  height: 100%;
  display: block !important;
}
.slide-down {
  position: relative;
  top: 0; /* 初始位置在按钮之上 */
  animation: slide-down 0.5s forwards; /* 动画名称，持续时间，填充模式 */
}
/* 创建关键帧动画 */
@keyframes slide-down {
  from {
    top: 0; /* 动画开始时的位置 */
    opacity: 0; /* 开始时透明度为0 */
  }
  to {
    top: 100%; /* 动画结束时的位置 */
    opacity: 1; /* 结束时透明度为1 */
  }
}
.slide-up-button {position: relative;top: 100%;animation: slide-up 0.5s forwards;}
@keyframes slide-up {from {top: 100%;transform: translateY(100%);opacity: 0;}to { top: 0;transform: translateY(0);opacity: 1;}}
</style>
<style>
.el-cascader-menu__wrap {height: 350px !important;}
</style>
